<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3 class="hidden-sm-and-down">Danh sách thiết bị ({{totalDevice}})</h3>
          <h4 class="hidden-md-and-up">Thiết bị ({{totalDevice}})</h4>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            class="hidden-sm-and-down"
            to="/device/import"
            v-if="loggedUser.isProvider"
          >Nhập thiết bị
            <v-icon right dark>add</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            to="/device/export"
            class="hidden-sm-and-down"
            v-if="displayButton"
          >Xuất thiết bị
            <v-icon right dark>import_export</v-icon>
          </v-btn>
          <v-btn
            dark
            color="teal"
            to="/device/return"
            class="hidden-sm-and-down"
            v-if="displayButton"
          >Thu hồi thiết bị
            <v-icon right dark>subdirectory_arrow_left</v-icon>
          </v-btn>

          <!-- <v-btn outline round color="primary">
            Bộ lọc 
            <v-icon right dark>filter_list</v-icon>
          </v-btn>-->
        </v-toolbar>
        <v-flex lg12>
          <device-table :isLoading="isLoading" :datasource="devices" :totalItems="totalDevice" @changePage="changePage" @exportFile="openDialogExportFile"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-speed-dial bottom right fixed class="hidden-md-and-up">
      <v-btn slot="activator" color="blue darken-2" dark fab to="/device/export">
        <v-icon>import_export</v-icon>
      </v-btn>
    </v-speed-dial>

    <!-- Dialog xuất file -->
    <dialog-export-file ref="dialogExportFile" :loading="loadingExportFile" @export="handleExportFile"/>
    <!-- Dialog xuất file -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import DeviceTable from './components/list';
import DialogExportFile from '@/components/dialog/DialogExportFile';
import XLSX from 'xlsx';

export default {
  components: {
    DeviceTable,
    DialogExportFile
  },
  data () {
    return {
      isLoading: false,
      pagination: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10
      },
      loadingExportFile: false,
      countExportFile: 0,
      devices: []
    };
  },
  computed: {
    ...mapGetters(['loggedUser', 'totalDevice']),
    // totalDevice () {
    //   return this.devices && this.devices.totalDevice;
    // },
    displayButton () {
      return this.loggedUser.isProvider || this.loggedUser.isDistributor;
    }
  },
  created () {
    // code
  },
  methods: {
    ...mapActions(['getDevices']),

    changePage (pagination) {
      this.pagination = { ...pagination };
      this.isLoading = true;
      this.getDevices(pagination).then(res => {
        this.devices = res;
        this.isLoading = false;
      });
    },

    openDialogExportFile () {
      let fileName = `Devices-${this.pagination.activedFilter}`;
      this.countExportFile = Math.ceil(this.totalDevice / 10000);
      this.$refs.dialogExportFile.open(this.countExportFile, fileName);
    },

    async handleExportFile (file) {
      let params = { ...this.pagination };
      params.pageSize = 10000;
      params.pageIndex = file.index;

      this.loadingExportFile = true;

      let listDevice = await this.getDevices(params).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      listDevice.map(item => {
        let account = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.accountName,
          Imei: item.imei,
          'Loại TB': item.deviceType,
          'Gói cước': item.planCode,
          'SĐT Sim': item.simPhone,
          'IccId': item.simSN,
          'Biển số xe': item.plate,
          'Ngày kích hoạt': item.activatedDate
            ? new Date(item.activatedDate).toISOString().slice(0, 10)
            : '',
          'Ngày tạo': new Date(item.createdDate).toISOString().slice(0, 10)
        };
        dataToExport.push(account);
        return 0;
      });
      console.log('handleExportFile -> dataToExport', dataToExport);

      let sheet = XLSX.utils.json_to_sheet(dataToExport);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'Devices');
      XLSX.writeFile(wb, `${file.name}.xlsx`);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/device/index.vue